<section id="invoice-form" class="invoice-form section">
   <div class="container section-title" data-aos="fade-up">
      <h2>Create<span> Invoice</span></h2>
      <p>Enter Invoice Details</p>
   </div>
   <div class="container">
      <div class="row">
         <div class="col-md-10 mx-auto">
            <div class="card">
               <div class="card-body">

                  <form [formGroup]="invoiceForm" (ngSubmit)="onSubmit()">
                     <!-- Invoice Details -->
                     <div class="row mb-3">
                        <div class="col-md-4">
                           <label class="form-label fw-bold required" for="">Invoice Number</label>
                           <input type="text" class="form-control" formControlName="invoiceNumber"
                              [class.is-invalid]="invoiceForm.get('invoiceNumber')?.invalid && invoiceForm.get('invoiceNumber')?.touched"
                              [attr.title]="invoiceForm.get('invoiceNumber')?.hasError('required') && invoiceForm.get('invoiceNumber')?.touched ? 'Invoice Number is required' : null"
                              data-bs-toggle="tooltip">

                           <!-- <div class="invalid-feedback">
                              Invoice Number is required
                           </div> -->
                        </div>

                        <div class="col-md-4">
                           <label class="form-label fw-bold required" for="">Invoice Date</label>
                           <input type="date" 
                           class="form-control" 
                           formControlName="invoiceDate" 
                           [class.is-invalid]="invoiceForm.get('invoiceDate')?.invalid && invoiceForm.get('invoiceDate')?.touched"
                           [attr.title]="invoiceForm.get('invoiceDate')?.hasError('required') && invoiceForm.get('invoiceDate')?.touched ? 'Invoice Date is required' : null"
                           data-bs-toggle="tooltip">

                           <!-- <div class="invalid-feedback">
                              Invoice Date is required
                           </div> -->
                        </div>

                        <div class="col-md-4">
                           <label class="form-label fw-bold required" for="">Invoice Due Date</label>
                           <input type="date" 
                           class="form-control" 
                           formControlName="dueDate" 
                           [class.is-invalid]="invoiceForm.get('dueDate')?.invalid &&  invoiceForm.get('dueDate')?.touched"
                           [attr.title]="invoiceForm.get('dueDate')?.hasError('required') && invoiceForm.get('dueDate')?.touched ? 'Due Date is required' : null"
                           data-bs-toggle="tooltip">

                           <!-- <div class="invalid-feedback">
                              Due Date is required
                           </div> -->
                        </div>
                     </div>
                     <!-- End Invoice Details -->

                     <hr />

                     <!-- Company & Client Selection -->
                     <div class="row mb-3">

                        <!-- Company Details -->
                        <kt-app-invoice-form-company [invoiceForm]="invoiceForm" [companies]="companies" (openPremiumModalEvent)="handleOpenPremiumModal($event)"></kt-app-invoice-form-company>
                        <!-- End Company Details -->

                        <!-- To -->
                        <kt-app-invoice-form-client [invoiceForm]="invoiceForm" [clients]="clients" (openPremiumModalEvent)="handleOpenPremiumModal($event)"></kt-app-invoice-form-client>
                        <!-- End To -->
                     </div>

                     <hr />

                     <!-- Line Items -->

                     <label class="form-label fw-bold required" for="">Invoice Items</label>

                     <div formArrayName="items">
                        @for (item of items.controls; track $index; let i = $index) {
                        <div class="row mb-3" [formGroupName]="i">

                           <!-- Description -->
                           <div class="col-md-4">
                              <label class="fw-bold required" for="">Description</label>
                              <input type="text" class="form-control" formControlName="description"
                                 [class.is-invalid]="items.at(i).get('description')?.invalid && items.at(i).get('description')?.touched">
                           </div>

                           <!-- Quantity -->
                           <div class="col-md-2">
                              <label class="fw-bold required" for="">Qty</label>
                              <input type="number" class="form-control" formControlName="quantityOrHours"
                                 (input)="calculateItemTotal(i)" (focus)="clearZeroInItem(i, 'quantityOrHours')"
                                 [class.is-invalid]="items.at(i).get('quantityOrHours')?.invalid && items.at(i).get('quantityOrHours')?.touched">
                           </div>

                           <!-- Rate -->
                           <div class="col-md-2">
                              <label class="fw-bold required" for="">Rate</label>
                              <input type="number" class="form-control" formControlName="unitPrice"
                                 (input)="calculateItemTotal(i)" (focus)="clearZeroInItem(i, 'unitPrice')"
                                 [class.is-invalid]="items.at(i).get('unitPrice')?.invalid && items.at(i).get('unitPrice')?.touched">
                           </div>

                           <!-- Total -->
                           <div class="col-md-2 d-flex align-items-end fw-bold">
                              {{ items.at(i).get('total')?.value | number:'1.2-2' }}
                           </div>

                           <!-- Remove -->
                           <div class="col-md-2 d-flex align-items-end">
                              <button type="button" class="btn btn-danger w-100" (click)="removeItem(i)">
                                 Remove
                              </button>
                           </div>

                        </div>
                        }
                     </div>

                     <div class="row">
                        <button type="button" class="btn btn-success" (click)="addItem()">
                           Add New Item
                        </button>
                     </div>
                     <!-- End Line Items -->

                     <hr />

                     <!-- Notes and Terms-->

                     <div class="row mt-3">
                        <div class="col-md-8">
                           <label class="form-label fw-bold" for="">Notes</label>
                           <textarea class="form-control mb-3" rows="3" formControlName="notes"></textarea>
                        </div>

                        <!-- <label class="form-label fw-bold" for="">Terms & Conditions</label>
                              <textarea class="form-control" rows="3" formControlName="terms"></textarea> -->

                        <div class="col-md-4">
                           <h4 class="text-end fw-bold text-decoration-underline">
                              Invoice Summary
                           </h4>

                           <div class="d-flex justify-content-end gap-3 mb-2 small text-muted">
                              <label>
                                 <input type="checkbox" class="form-check-input" (change)="toggleTaxInput()" checked>
                                 Tax
                              </label>
                              <label>
                                 <input type="checkbox" class="form-check-input" (change)="toggleDiscountInput()">
                                 Discount
                              </label>
                              <label>
                                 <input type="checkbox" class="form-check-input" (change)="toggleShippingInput()">
                                 Shipping
                              </label>
                           </div>

                           <div class="row mb-2">
                              <div class="col text-end">Subtotal:</div>
                              <div class="col text-end">{{subtotal | appCurrency:companyCurrency }}</div>
                           </div>

                           @if(showDiscountInput){
                           <div class="row mb-2 align-items-center">
                              <div class="col text-end">Discount</div>
                              <div class="col">
                                 <input type="number" class="form-control form-control-sm"
                                    formControlName="discountAmount" (focus)="clearZero('discountAmount')"
                                    [class.is-invalid]="invoiceForm.get('discountAmount')?.invalid && invoiceForm.get('discountAmount')?.touched">
                              </div>
                           </div>
                           }

                           @if(showShippingInput){
                           <div class="row mb-2 align-items-center">
                              <div class="col text-end">Shipping</div>
                              <div class="col">
                                 <input type="number" class="form-control form-control-sm"
                                    formControlName="shippingAmount" (focus)="clearZero('shippingAmount')"
                                    [class.is-invalid]="invoiceForm.get('shippingAmount')?.invalid && invoiceForm.get('shippingAmount')?.touched">
                              </div>
                           </div>
                           }

                           @if(showTaxInput){
                           <div class="row mb-2 align-items-center">
                              <div class="col text-end">Tax (%)</div>
                              <div class="col">
                                 <input type="number" class="form-control form-control-sm"
                                    formControlName="taxPercentage"
                                    [class.is-invalid]="invoiceForm.get('taxPercentage')?.invalid && invoiceForm.get('taxPercentage')?.touched">
                              </div>
                           </div>
                           }

                           <div class="row mb-2 fw-bold">
                              <div class="col text-end">Total:</div>
                              <div class="col text-end">{{ total | appCurrency:companyCurrency }}</div>
                           </div>

                        </div>
                     </div>

                     <!-- End Notes and Terms-->

                     <!-- Actions -->

                     <div class="d-flex justify-content-end mt-3">
                        <button type="submit" class="btn btn-success me-2"
                           [disabled]="invoiceForm.invalid || items.length === 0">
                           Create & Preview
                        </button>

                        <button type="button" class="btn btn-danger" (click)="resetForm()">
                           Reset
                        </button>
                     </div>

                     <!-- End Actions-->

                     <label class="form-label required mt-2" for="">* Required fields</label>
                  </form>

               </div>
            </div>
         </div>
      </div>
   </div>
</section>

<!-- Login Modal -->
<kt-app-login-modal #loginModal (loginSuccess)="onLoginSuccess()" />

<kt-app-premium-modal />